const rankings = [
  { rank: 1, title: '某顶流深夜密会神秘女子，多组实锤照片曝光', heat: '9.8', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名综艺导演组内讧升级，录制现场一度失控', heat: '9.5', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '当红小花旦疑似怀孕停工，工作室含糊回应引猜测', heat: '9.2', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '某男团成员被曝私联粉丝，聊天记录遭泄露', heat: '8.8', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '娱乐圈大佬资本局曝光：对赌协议暗藏玄机', heat: '8.5', tag: '新', tagColor: 'bg-secondary-500' },
];

export default function RankingSection() {
  const getRankColor = (rank: number) => {
    if (rank === 1) return 'text-primary-600';
    if (rank === 2) return 'text-accent-600';
    if (rank === 3) return 'text-secondary-600';
    return 'text-foreground-400';
  };

  return (
    <section id="ranking" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              吃瓜热榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时热度排行，看看大家都在关注什么</p>
          </div>
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-foreground-400">
            每小时更新
            <i className="ri-refresh-line"></i>
          </span>
        </div>
        <div className="max-w-3xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 py-3.5 border-b border-background-200/70 last:border-b-0 hover:bg-background-100/80 px-3 -mx-3 rounded-md transition-colors cursor-pointer"
            >
              <span className={`font-heading text-xl md:text-2xl w-8 text-center flex-shrink-0 ${getRankColor(item.rank)}`}>
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 leading-relaxed hover:text-primary-600 transition-colors line-clamp-2 min-w-0">
                {item.title}
              </span>
              <span className={`px-2 py-0.5 rounded text-[10px] font-medium text-background-50 whitespace-nowrap flex-shrink-0 ${item.tagColor}`}>
                {item.tag}
              </span>
              <span className="text-sm font-medium text-primary-600 flex-shrink-0 w-12 text-right">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}